import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '@tsin-shared/components/footer/footer.component';
import { MainHeaderComponent } from '@tsin-shared/components/main-header/main-header.component';

@Component({
  selector: 'app-user',
  imports: [
    MainHeaderComponent,
    RouterModule,
    CommonModule,
    MainHeaderComponent,
    FooterComponent,
  ],
  templateUrl: './user.layout.html',
  styleUrl: './user.layout.css'
})
export class UserLayout {

}
